import {
    ConversationMessage,
    RCSInboundMessage,
    RCSOutboundMessage,
    SMSOutboundMessage
} from "@/conversation/interfaces/index";

export const isSMSOutbound = (message: ConversationMessage): message is SMSOutboundMessage => {
    return message.channel === 'sms' && message.direction === 'outbound';
};

/**
 * Check if a conversation message is an outbound RCS message.
 */
export const isRCSOutbound = (message: ConversationMessage): message is RCSOutboundMessage => {
    return message.channel === 'rcs' && message.direction === 'outbound';
};

/**
 * Check if a conversation message is an inbound RCS message.
 */
export const isRCSInbound = (message: ConversationMessage): message is RCSInboundMessage => {
    return message.channel === 'rcs' && message.direction === 'inbound';
};
